import { render, staticRenderFns } from "./EntryDisplay.vue?vue&type=template&id=1c291b49&scoped=true&"
import script from "./EntryDisplay.vue?vue&type=script&lang=js&"
export * from "./EntryDisplay.vue?vue&type=script&lang=js&"
import style0 from "./EntryDisplay.vue?vue&type=style&index=0&id=1c291b49&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c291b49",
  null
  
)

/* custom blocks */
import block0 from "@/translations/EntryDisplay.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fcodebuild%2Foutput%2Fsrc665095227%2Fsrc%2Ffincraft-app%2Fsrc%2Fcomponents%2Fcommon%2Flexicon%2FLexiconOverlay%2FEntryDisplay.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports